<template>
  <div class="page-content modifyAccountBox">
    <a-card :loading="false">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" v-bind="layout">
        <a-form-model-item :colon="false" has-feedback label="账号" prop="account">
          <a-input v-model="ruleForm.account" placeholder="请输入账号" :max-length="32" disabled autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item :colon="false" has-feedback label="姓名" prop="realName">
          <a-input v-model="ruleForm.realName" placeholder="请输入姓名" :max-length="30" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item :colon="false" has-feedback label="手机号" prop="mobile">
          <a-input v-model="ruleForm.mobile" placeholder="请输入手机号" :max-length="11" type="age" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" :loading="loading.handleSave" @click="submitForm('ruleForm')">完成</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import loadingMixin from "@thales/loading";
import { mapState } from "vuex";
import { editAccount } from "./api"

export default {
  mixins: [loadingMixin],
  data() {
    return {
      loading: {
        handleSave: false,
      },
      ruleForm: {
        account: "",
        realName: "",
        mobile: "",
      },
      rules: {
        realName: [
          { required: true, message: "请输入姓名", trigger: "change" },
          { max: 30, message: "长度不超过30字符", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { max: 11, min: 11, message: "请输入正确的手机号", trigger: "change" },
        ],
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 8 },
      },
    };
  },
  computed: {
    ...mapState("user", ["userId", "realName", "account", "mobile", 'accountId']),
  },
  mounted() {
    this.ruleForm.account = this.account;
    this.ruleForm.mobile = this.mobile;
    this.ruleForm.realName = this.realName;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            accountId: this.accountId,
            account: this.ruleForm.account,
            realName: this.ruleForm.realName,
            mobile: this.ruleForm.mobile,
          }
          editAccount(data).then(() => {
            const userData = this.$store.state.user
            const form = {
              clientCode: 'customer_account',
              userId: userData.userId,
              customerId: userData.customerId
            }
            this.$store.dispatch('user/login', {form, type: 'resetlogin'}).finally(() => {
              this.loading = false
            })
            this.$router.go(-1)
          })
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.modifyAccountBox {
  ::v-deep .ant-card {
    border-radius: 4px;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
</style>